// extracted by mini-css-extract-plugin
export default {"alert":"ManageDepartmentStaffModal_alert__pSuFT"};